// Canonical pricing and Shopify variant lookup for custom madeleines.
(() => {
  const tiers = Object.freeze({
    '30': Object.freeze([
      Object.freeze({ min: 30, max: 50, unitPriceCents: 280, label: '30–50' }),
      Object.freeze({ min: 51, max: 100, unitPriceCents: 260, label: '51–100' }),
      Object.freeze({ min: 101, max: 200, unitPriceCents: 240, label: '101–200' })
    ]),
    '55': Object.freeze([
      Object.freeze({ min: 30, max: 50, unitPriceCents: 340, label: '30–50' }),
      Object.freeze({ min: 51, max: 100, unitPriceCents: 320, label: '51–100' }),
      Object.freeze({ min: 101, max: 200, unitPriceCents: 290, label: '101–200' })
    ])
  });
  const handles = Object.freeze({ '30': 'madeleine-personnalisable-30-g', '55': 'madeleine-personnalisable-55-g' });
  const products = new Map();

  const tierFor = (weight, quantity) => tiers[weight]?.find((tier) => quantity >= tier.min && quantity <= tier.max) || null;
  const weightFromItem = (item) => String(item.properties?.Format || '').match(/(30|55)\s*g/)?.[1] || null;
  const loadProduct = async (weight) => {
    if (products.has(weight)) return products.get(weight);
    const response = await fetch(`/products/${handles[weight]}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Custom product lookup failed');
    const product = await response.json();
    products.set(weight, product);
    return product;
  };
  const variantFor = async (weight, quantity) => {
    const tier = tierFor(weight, quantity);
    if (!tier) return null;
    const product = await loadProduct(weight);
    return product.variants.find((variant) => variant.option1 === tier.label) || null;
  };

  window.ProostCustomMadeleinePricing = Object.freeze({ tiers, tierFor, weightFromItem, variantFor });
})();
